import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-link-ascend',
  templateUrl: './link-ascend.component.html',
  styleUrls: ['./link-ascend.component.scss']
})
export class LinkAscendComponent {

    @Input() partner;
    @Input() selectedPOS;
    @Input() modal;
    @Output() next = new EventEmitter();

    public connected = false;

}
